import React from 'react'

const Section3 = () => {
  return (
    <div class="section inner">
      <h4>Create private memories via Direct Message</h4>
      <p class="sub">
        Message FreeMinder directly to create memories that are only visible to you
      </p>
      <ul id="memories">
        <li>
          <div class="content">
            <h3>@mikebrown Birthday party</h3>
            <p>6 June 2021</p>
          </div>
          <div class="meta">
            <span class="platform">
              <i class="fa fa-slack" aria-hidden="true"></i>
            </span>
            <div class="clear"></div>
          </div>
        </li>
      </ul>
    </div>
  );
}

export default Section3
